<template>
  <div></div>
</template>
<script>
import { EventBus } from '@/components/eventbus/EventBus'
import { ON_CLICK, ON_DISPLAY, FLUSH_EVENT } from '@/common/event.const'
import { map, clone } from 'lodash'
import { AnalizeService } from '@/common/api/api.service'

export default {
  name: 'EventProcessor',
  data () {
    return {
      eventQueue: [],
      timer: 5000,
      eventTimer: null
    }
  },
  methods: {
    deepCopy (list) {
      return map(list, clone)
    },
    flushEventQueue () {
      if (this.eventQueue.length === 0) {
        clearTimeout(this.eventTimer)
        return
      }
      const copyList = this.deepCopy(this.eventQueue)
      this.eventQueue = []
      this.sendEventLogList(copyList)
    },
    addEvent (event) {
      this.eventQueue.push(event)
    },
    sendEventLogList (list) {
      if (list.length === 0) return
      AnalizeService.sendLogList(list.filter(event => event !== undefined))
    }
  },
  mounted () {
    EventBus.$on(ON_DISPLAY, event => {
      this.addEvent(event)
    })
    EventBus.$on(ON_CLICK, event => {
      this.addEvent(event)
    })
    EventBus.$on(FLUSH_EVENT, () => {
      this.flushEventQueue()
    })
  },
  watch: {
    eventQueue () {
      clearTimeout(this.eventTimer)
      this.eventTimer = setTimeout(() => {
        this.flushEventQueue()
      }, this.timer)
    }
  }
}
</script>
